/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FSProperties
 */
export interface FSProperties {
    /**
     * 
     * @type {boolean}
     * @memberof FSProperties
     */
    needsSshConnection?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FSProperties
     */
    supportsDirectoryQuotas?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FSProperties
     */
    supportsWorkspaceQuotas?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FSProperties
     */
    supportsSoftQuotas?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FSProperties
     */
    supportsUserQuotas?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FSProperties
     */
    supportsGroupQuotas?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FSProperties
     */
    supportsXattrs?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FSProperties
     */
    supportsSnapshots?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FSProperties
     */
    creatingDirectoryQuotaDestroysContent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FSProperties
     */
    removingDirectoryQuotaDestroysContent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FSProperties
     */
    supportsPosixPermissions?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FSProperties
     */
    supportsDates?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FSProperties
     */
    supportsRenaming?: boolean;
}

export function FSPropertiesFromJSON(json: any): FSProperties {
    return FSPropertiesFromJSONTyped(json, false);
}

export function FSPropertiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): FSProperties {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'needsSshConnection': !exists(json, 'needs_ssh_connection') ? undefined : json['needs_ssh_connection'],
        'supportsDirectoryQuotas': !exists(json, 'supports_directory_quotas') ? undefined : json['supports_directory_quotas'],
        'supportsWorkspaceQuotas': !exists(json, 'supports_workspace_quotas') ? undefined : json['supports_workspace_quotas'],
        'supportsSoftQuotas': !exists(json, 'supports_soft_quotas') ? undefined : json['supports_soft_quotas'],
        'supportsUserQuotas': !exists(json, 'supports_user_quotas') ? undefined : json['supports_user_quotas'],
        'supportsGroupQuotas': !exists(json, 'supports_group_quotas') ? undefined : json['supports_group_quotas'],
        'supportsXattrs': !exists(json, 'supports_xattrs') ? undefined : json['supports_xattrs'],
        'supportsSnapshots': !exists(json, 'supports_snapshots') ? undefined : json['supports_snapshots'],
        'creatingDirectoryQuotaDestroysContent': !exists(json, 'creating_directory_quota_destroys_content') ? undefined : json['creating_directory_quota_destroys_content'],
        'removingDirectoryQuotaDestroysContent': !exists(json, 'removing_directory_quota_destroys_content') ? undefined : json['removing_directory_quota_destroys_content'],
        'supportsPosixPermissions': !exists(json, 'supports_posix_permissions') ? undefined : json['supports_posix_permissions'],
        'supportsDates': !exists(json, 'supports_dates') ? undefined : json['supports_dates'],
        'supportsRenaming': !exists(json, 'supports_renaming') ? undefined : json['supports_renaming'],
    };
}

export function FSPropertiesToJSON(value?: FSProperties | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'needs_ssh_connection': value.needsSshConnection,
        'supports_directory_quotas': value.supportsDirectoryQuotas,
        'supports_workspace_quotas': value.supportsWorkspaceQuotas,
        'supports_soft_quotas': value.supportsSoftQuotas,
        'supports_user_quotas': value.supportsUserQuotas,
        'supports_group_quotas': value.supportsGroupQuotas,
        'supports_xattrs': value.supportsXattrs,
        'supports_snapshots': value.supportsSnapshots,
        'creating_directory_quota_destroys_content': value.creatingDirectoryQuotaDestroysContent,
        'removing_directory_quota_destroys_content': value.removingDirectoryQuotaDestroysContent,
        'supports_posix_permissions': value.supportsPosixPermissions,
        'supports_dates': value.supportsDates,
        'supports_renaming': value.supportsRenaming,
    };
}


